/* This example requires Tailwind CSS v2.0+ */
export default function Container(props) {
    return <div className={`${props?.className} w-full py-4 mx-auto sm:px-6 lg:px-8`}>{props?.children}</div>
  }
  